/* NO-BANNER-ROTATE, 2026-09-28. The top bar's country lines, one at a time.

   ONE NEW FILE ONLY, so the look and the behaviour both live here: the styles
   are injected once at the top of this file rather than shipped as a second
   asset. The words, the links and the country all come from Liquid and are
   already in the page before this file loads. This file decides nothing about
   what is true; it only decides which true line is showing.

   THE ONE RULE IT EXISTS FOR: the header must not move when the line changes.
   Every line sits in the SAME css grid cell, so the box is always as tall as its
   tallest line and nothing below it shifts. A rotation that swapped display none
   for display block would jog the header on every change, which is exactly what
   the eye catches.

   WHAT IT DOES NOT DO. It does not read a country, a timezone, a language or an
   IP: the market was settled server side and written into the markup. It does
   not fetch. It does not touch the theme's splide slider, because our lines are
   not in the splide track.

   FAILURE IS SAFE. With JavaScript blocked, or if this file 404s, Liquid has
   already marked the first line is-on and the bar reads correctly. It just does
   not rotate.

   No em or en dashes in this file. */
(function () {
  'use strict';

  var HOLD_MS = 5000;
  var STYLE_ID = 'no-banner-rotate-css';

  /* ------------------------------------------------------------- the styles
     Injected once, guarded by id so a second copy of this script (a section
     re render in the theme editor, say) cannot stack a second <style>. */
  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '.no-banner{display:grid;align-items:center;justify-items:center;width:100%;}',
      /* every line in one cell: the tallest sets the height for all of them */
      '.no-banner__line{grid-area:1/1;margin:0;text-align:center;opacity:0;visibility:hidden;transition:opacity .45s ease;}',
      '.no-banner__line.is-on{opacity:1;visibility:visible;}',
      '.no-banner__link,.no-banner__link:visited{color:inherit;text-decoration:none;}',
      '.no-banner__link:hover,.no-banner__link:focus-visible{text-decoration:underline;text-underline-offset:.2em;}',
      '@media (prefers-reduced-motion: reduce){.no-banner__line{transition:none;}}'
    ].join('');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    (document.head || document.documentElement).appendChild(el);
  }

  function reduced() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function start(root) {
    if (!root || root.dataset.noBannerReady === '1') return;
    root.dataset.noBannerReady = '1';

    var lines = root.querySelectorAll('[data-no-banner-line]');
    if (lines.length < 2) return; /* one true line is not a rotation */

    var at = 0;
    var timer = null;
    var paused = false;

    function show(next) {
      lines[at].classList.remove('is-on');
      lines[at].setAttribute('aria-hidden', 'true');
      at = next % lines.length;
      lines[at].classList.add('is-on');
      lines[at].removeAttribute('aria-hidden');
    }

    function tick() {
      if (!paused && !document.hidden) show(at + 1);
      timer = window.setTimeout(tick, HOLD_MS);
    }

    /* SOMEONE WHO ASKED THEIR SYSTEM TO STOP ANIMATIONS SEES THE FIRST LINE AND
       NOTHING MOVES. Their line is still a true line, so nothing is lost. */
    if (reduced()) return;

    /* PAUSES WHILE THE POINTER IS ON THE BAR, so a line cannot slide away from
       under someone who is reading it or reaching for its link. Keyboard focus
       counts as reading too. */
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    timer = window.setTimeout(tick, HOLD_MS);

    /* A BACKGROUND TAB DOES NOT ROTATE. document.hidden is checked in tick, so a
       tab left open for an hour comes back on a sane line rather than having
       burned through hundreds of swaps. */
    window.addEventListener('pagehide', function () {
      if (timer) window.clearTimeout(timer);
    });
  }

  function boot() {
    styles();
    var roots = document.querySelectorAll('[data-no-banner]');
    for (var i = 0; i < roots.length; i++) start(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor rebuilds a section without reloading the page, which drops
     a fresh bar in with no script attached. Shopify announces it; we re boot. */
  document.addEventListener('shopify:section:load', boot);
})();
